import { Link } from "react-router-dom"
import { ResultType } from "../../../models/news-articles/regulatory-focus/feature-focus-model"

type NewsAndArticleCardTypes = {
  cardSecTitle: string
  cardSecSubTitle: string
  cardSecContent: string
  cardSecInfo: string
  article: ResultType
}

const NewsArticleFeatureCards = (props: NewsAndArticleCardTypes) => {
  const article = props.article
  return <div className={props.cardSecTitle}>
    <Link to={article.linkUrl}>
      <div className={props.cardSecSubTitle}>{article.title}</div>
    </Link>
    <Link to={article?.articlePages[0]?.articleUrl}>
      <img src={article?.articlePages[0]?.articleTeaserImage} alt={article?.articlePages[0]?.articleName} loading="lazy" />
    </Link>
    <div className={props.cardSecContent}>
      <div className={props.cardSecInfo} >
        <ul>
          {(article?.articlePages.length > 1) ? (
              article?.articlePages.map((item, index) => {
                return <li key={index}>
                  <Link to={item.articleUrl} dangerouslySetInnerHTML={{ __html: item.articleName }}></Link>
                </li>
              })
            ) : (
              <li>
                <Link to={article?.articlePages[0].articleUrl} dangerouslySetInnerHTML={{ __html: article?.articlePages[0]?.articleName }}></Link>
                <p dangerouslySetInnerHTML={{ __html: article?.articlePages[0]?.articleTeaserText }}></p>
              </li>
            )}
        </ul>
      </div>
    </div>
    {(article?.articlePages.length > 1) && <Link to={article.linkUrl} className="view-more">See more</Link>}
  </div>
}

export default NewsArticleFeatureCards
